import React from 'react';
import { motion } from 'framer-motion';
import { Star, MapPin } from 'lucide-react';
const testimonials = [{
  initials: 'CG',
  name: 'Carlos G.',
  location: 'Buenos Aires',
  role: 'Docente de Física Secundaria',
  quote: '"Compré el MegaPack un domingo a la noche. El lunes tenía todo el año de Física organizado. Las fichas ilustradas son exactamente lo que mis alumnos necesitaban para entender las fórmulas sin que parezca un libro de texto."',
  color: 'bg-blue-600'
}, {
  initials: 'MG',
  name: 'Mariana G.',
  location: 'GBA',
  role: 'Docente de Física Secundaria',
  quote: '"El Tomo 7 me salvó la Muestra Anual. El brazo hidráulico con jeringas quedó perfecto y mis alumnos lo explicaron solos con el guión que venía incluido. El jurado quedó impresionado."',
  color: 'bg-indigo-600'
}, {
  initials: 'LG',
  name: 'Laura G.',
  location: 'Córdoba',
  role: 'Profesora de Física y Química',
  quote: '"Lo que más valoro es que está organizado POR AÑO. No tengo que adivinar qué le corresponde a cada curso. Todo ya está pensado, ordenado y alineado al diseño curricular. Mis colegas me preguntaron cómo preparar todo tan bien."',
  color: 'bg-sky-600'
}];
export function DetailedTestimonials() {
  return <section className="py-8 md:py-20 px-4 bg-sky-50" data-id="element-44">
      <div className="max-w-6xl mx-auto" data-id="element-45">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-center text-slate-900 mb-6 md:mb-16" data-id="element-46">
          Lo que dicen los docentes
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-47">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-[2rem] shadow-xl shadow-blue-900/5 border border-blue-100 flex flex-col" data-id="element-48">
              <div className="flex gap-1 mb-4" data-id="element-49">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-blue-600 text-blue-600" data-id="element-50" />)}
              </div>

              <blockquote className="text-slate-800 font-bold text-sm md:text-lg leading-relaxed mb-8 flex-1 italic" data-id="element-51">
                {t.quote}
              </blockquote>

              <div className="flex items-center gap-4 pt-6 border-t border-slate-50" data-id="element-52">
                <div className={`${t.color} w-12 h-12 rounded-2xl flex items-center justify-center text-white font-black text-lg shadow-lg shrink-0`} data-id="element-53">
                  {t.initials}
                </div>
                <div data-id="element-54">
                  <p className="font-black text-slate-900 text-sm md:text-base" data-id="element-55">
                    {t.name}
                  </p>
                  <div className="flex items-center gap-1 text-slate-500 font-medium text-[10px] md:text-xs" data-id="element-56">
                    <MapPin size={12} data-id="element-57" />
                    <span data-id="element-58">
                      {t.location} | {t.role}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}